import AppDispatcher from "../dispatcher/AppDispatcher"
import Constants from "../constants/Constants"
import 'whatwg-fetch'
import config from 'react-global-configuration';
import cookie from 'react-cookies'


var CardActions = {
  update(name,value){

    AppDispatcher.dispatch({
      actionType: Constants.UPDATE_CARD,
      name: name,
      value:value
    })

  },

  getAvailableCard(){
    window.Payjp.setPublicKey(config.get("PAY_JP_KEY"));
    window.Payjp.retrieveAvailability( function(status, response) {
      if (status == 200) {
        //console.log(response)
        /*
        AppDispatcher.dispatch({

        })*/

      } else {
        console.log(response)
      };
    });

  },
  createToken(token, citem){

    var card = {
      number: citem.number,
      cvc: citem.cvc,
      exp_month: citem.exp_month,
      exp_year:2000 +  Number(citem.exp_year)
    };

    window.Payjp.setPublicKey(config.get("PAY_JP_KEY"));

    window.Payjp.createToken(card, function(status, response) {

      if (status == 200) {
      /*  AppDispatcher.dispatch({
          actionType: Constants.UPDATE_TOKEN,
          token:response.id
        })*/
        CardActions.paymentExe(token,response.id)
      } else {
        AppDispatcher.dispatch({
          actionType: Constants.ERROR_CARD,
          code: status
        })
      };
    });
  },
  paymentExe(token,pay_token){

    fetch(config.get("API_PATH") + config.get("API_PAYMENT_CREATE").url, {
      method: config.get("API_PAYMENT_CREATE").method,
      headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify({
       access_token: token,
       data:{

         card_token:pay_token
       }
    })
    }).then(function(response) {
      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return response.status
      }else{
        return response.status
      }
    }).then(function(data) {

      if(data != null && data.status && data.status == 1){

        AppDispatcher.dispatch({
          actionType: Constants.PAYMENT_DONE,
        })
      }else{

        AppDispatcher.dispatch({
          actionType: Constants.ERROR_PAY,
          code:data
        })
      }
    })


  }
  /*
  update(name,value){


    AppDispatcher.dispatch({
      actionType: BookConstants.UPDATE,
      name: name,
      value:value
    })

  },

  addOption(value){

    AppDispatcher.dispatch({
      actionType: BookConstants.ADD_OPTION,
      value:value
    })

  },
  */




}

export default CardActions



// WEBPACK FOOTER //
// ./src/actions/CardActions.js